<div class="flex min-w-0 flex-1 flex-col">
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1 p-6">
    <aura-data-table
      matSort
      [inputColumns]="columns()"
      [filters]="filters()"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [searchPlaceHolder]="'Rechercher par ID session (ex: vs_...)'"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerRefresh)="triggerRefresh()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <core-stripe-verification-sessions-data-table-filter
          [dto]="appliedFilter()"
          [filters]="filters()"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      @for (column of columns(); track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold text-primary"
            >
              {{ column.label }}
            </th>
            @switch (column.key) {
              @case ('stripeSessionId') {
                <td mat-cell *matCellDef="let session" class="font-mono text-xs">
                  {{ session.stripeSessionId }}
                </td>
              }
              @case ('user') {
                <td mat-cell *matCellDef="let session">
                  @if (session.userId && session.userId.identity) {
                    <span class="font-semibold"
                      >{{ session.userId.identity.firstName }} {{ session.userId.identity.lastName }}</span
                    >
                    <span class="text-xs text-gray-500 block">{{ session.userId.email }}</span>
                  } @else {
                    <span class="text-xs font-mono text-gray-400">{{ session.userId }}</span>
                  }
                </td>
              }
              @case ('stripeReportId') {
                <td mat-cell *matCellDef="let session" class="font-mono text-xs">
                  {{ session.stripeReportId || '-' }}
                </td>
              }
              @case ('createdAt') {
                <td mat-cell *matCellDef="let session">
                  {{ session.createdAt | luxonDate: 'dd/LL/yyyy HH:mm' }}
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let session">
                  {{ session[column.key] }}
                </td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
